module.exports = __webpack_public_path__ + "static/media/stage_empty.a7e0ab62.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/stage_empty.jpeg
// module id = 1194
// module chunks = 0